import { IOfferListTableLang, OFFER_LIST_TABLE_LANG_KEY } from './interface.IOfferListTableLang'
import { IOfferListModalLang, OFFER_LIST_MODAL_LANG_KEY } from './interface.IOfferListModalLang'

export * from './interface.IOfferListTableLang'
export * from './interface.IOfferListModalLang'

export type IOfferAllLang =
	& IOfferListTableLang
	& IOfferListModalLang

export const OFFER_ALL_LANG_KEY: IOfferAllLang = {
	...OFFER_LIST_MODAL_LANG_KEY,
	...OFFER_LIST_TABLE_LANG_KEY
}
